import { addBusinessDays } from 'date-fns'
import { DateLike, isTradingDay } from 'utils'

export const getNextAvailableBusinessDate = (holidayDates: DateLike[]): Date => {
  let nextAvailableBusinessDate = new Date()

  while (!isTradingDay(nextAvailableBusinessDate, holidayDates)) {
    nextAvailableBusinessDate = addBusinessDays(nextAvailableBusinessDate, 1)
  }

  return nextAvailableBusinessDate
}
